import { LangContext } from "../contexts/langContext";
import { useContext } from "react";
import HTMLRenderer from "./HTMLRenderer";
import { CorrectOrIncorrect, Question } from "@common";

const QuestionResultDescription: React.FC<{
  question: Question | undefined;
  correctOrIncorrect: CorrectOrIncorrect;
  answerDescription?: string;
}> = ({ question, correctOrIncorrect, answerDescription = "" }) => {
  const { translateTranslationData } = useContext(LangContext);
  const defaultDesc =
    question === undefined
      ? ""
      : correctOrIncorrect === "correct"
      ? translateTranslationData(question.correctResultDescInnerHTML)
      : translateTranslationData(question.incorrectResultDescInnerHTML);

  const desc = answerDescription !== "" ? answerDescription : defaultDesc;
  return (
    <HTMLRenderer
      style={{
        marginTop: 0,
        textAlign: "center",
      }}
    >
      {desc}
    </HTMLRenderer>
  );
};

export default QuestionResultDescription;
